import TreeViewContainer from "../../../Components/BonusUi/TreeView/TreeViewContainer";

const Tree = () => {
  return <TreeViewContainer />;
};

export default Tree;
